import { render, staticRenderFns } from "./Natales.vue?vue&type=template&id=070c54f9"
import script from "./Natales.vue?vue&type=script&lang=js"
export * from "./Natales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports